/**
 * The two review enums the route search schemas need, in a module that imports
 * nothing.
 *
 * Same bundle decision as `offer-vocabulary.ts`: `router.tsx` imports every
 * route's `validateSearch` schema EAGERLY, so anything a search module reaches
 * for lands in the initial chunk. `reviews.route.search.ts` needed one
 * lifecycle enum and `review-cycle-detail.route.search.ts` needed one
 * participant-status enum, and both were reaching into
 * `schemas/review-cycle.schema.ts`, a 400-line module of cycle, settings,
 * participant and rollout wire schemas. Two string tuples cost bytes nobody
 * notices; that module cost about a kilobyte gzipped against a 150 KB budget.
 *
 * The tuples are the single source of truth: `review-cycle.schema.ts` builds
 * its Zod enums from them, so the URL parser and the wire parser cannot drift.
 */

/// Mirror of the shore's review cycle lifecycle vocabulary, in its order.
export const REVIEW_LIFECYCLES = [
  "draft",
  "scheduled",
  "active",
  "paused",
  "completed",
  "archived",
] as const;
export type ReviewLifecycleName = (typeof REVIEW_LIFECYCLES)[number];

/// Mirror of the shore's per-participant status vocabulary, in its order.
export const REVIEW_PARTICIPANT_STATUSES = [
  "not_started",
  "self_submitted",
  "peer_complete",
  "manager_submitted",
  "signed_off",
  "rollout_complete",
  "waived",
  "excluded",
] as const;
export type ReviewParticipantStatusName = (typeof REVIEW_PARTICIPANT_STATUSES)[number];
